import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.sort";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import { loading, enumData, userPrefPageSize } from '@/decorators';
import chooseExportField from '@/components/chooseExportField';
import BulkSearchModal from '@/views/components/bulkSearchModal/index.vue';
import BatchAddEditModal from './components/batchAddEditModal.vue';
import AddEditModal from './components/addEditModal.vue';
import printComplianceOfficerModal from '@/views/components/printComplianceOfficerModal';
import DetailModal from '../complianceOfficer/detailModal.vue';
import util from '@/utils/util';
var addEditModalCom = util.mountVueComponent(AddEditModal);

var MaintenanceComplianceOfficerPage = function (_super) {
  __extends(MaintenanceComplianceOfficerPage, _super);

  function MaintenanceComplianceOfficerPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.loadingStatus = false;
    _this.columns = [];
    _this.data = [];
    _this.total = 0;
    _this.searchData = _this.initSearchData();
    _this.docValue = '';
    _this.selectedIdList = [];
    _this.selectedList = [];
    _this.addEditVisible = false;
    _this.rowSelection = {};
    _this.addEditData = {
      type: '',
      title: '',
      list: [],
      isGB: undefined
    };
    _this.productCateList = [];
    _this.isAllImportCountry = false;
    _this.rowData = {
      id: undefined,
      type: '',
      title: ''
    };
    _this.detailVisible = false;
    _this.maintenanceProductStatusEnum = [];
    _this.maintenanceProductFieldEnum = [];
    _this.maintenanceProductExportFieldEnum = [];
    _this.boolEnumList = [];
    _this.agentTypeEnum = [];
    _this.agentNameTypeEnum = [];
    _this.productNameLangEnum = [];
    return _this;
  }

  Object.defineProperty(MaintenanceComplianceOfficerPage.prototype, "booleanEnumList", {
    get: function get() {
      if (this.boolEnumList) {
        var enumList = this.$util.deepCopy(this.boolEnumList);
        enumList.sort(function (a, b) {
          return b.value - a.value;
        });
        return enumList;
      }

      return [];
    },
    enumerable: false,
    configurable: true
  });

  MaintenanceComplianceOfficerPage.prototype.created = function () {
    var _this = this;

    this.columns = [{
      title: this.t('商品编码'),
      dataIndex: 'product_sku',
      name: 'product_sku',
      scopedSlots: {
        customRender: 'product_sku'
      }
    }, {
      title: this.t('谷仓商品条码'),
      dataIndex: 'product_barcode',
      name: 'product_barcode',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('参考编码'),
      dataIndex: 'product_reference_number',
      name: 'product_reference_number',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('中文名称'),
      dataIndex: 'product_name_cn',
      name: 'product_name_cn',
      filterEmpty: true
    }, {
      title: this.t('英文名称'),
      dataIndex: 'product_name_en',
      name: 'product_name_en',
      filterEmpty: true
    }, {
      title: this.t('商品品类'),
      dataIndex: 'category_name',
      name: 'category_name',
      filterEmpty: true
    }, {
      title: this.t('是否需英代'),
      dataIndex: 'is_need_compliancer_text',
      name: 'is_need_compliancer_text',
      filterEmpty: true
    }, {
      title: this.t('合规负责人编码'),
      dataIndex: 'compliance_officer_no',
      name: 'compliance_officer_no',
      scopedSlots: {
        customRender: 'compliance_officer_no'
      },
      width: 250
    }, {
      title: this.t('公司信息'),
      dataIndex: 'current_compliance_officer',
      name: 'current_compliance_officer',
      scopedSlots: {
        customRender: 'current_compliance_officer'
      },
      width: 250
    }, {
      title: this.t('状态'),
      dataIndex: 'audit_status_text',
      name: 'audit_status_text',
      scopedSlots: {
        customRender: 'audit_status_text'
      }
    }, {
      title: this.t('操作'),
      key: 'operation',
      dataIndex: 'operation',
      name: 'operation',
      fixed: 'right',
      showColumnSetting: true,
      scopedSlots: {
        customRender: 'operation'
      },
      width: 100
    }];
    this.rowSelection = {
      selectedRowKeys: [],
      onChange: function onChange(selectedRowKeys, selectedRow) {
        _this.rowSelection.selectedRowKeys = _this.selectedIdList = selectedRowKeys;
        _this.selectedList = selectedRow;
      }
    };
    this.queryList(this.searchData);
    this.queryProductCateList();
  };

  MaintenanceComplianceOfficerPage.prototype.queryList = function (params) {
    return __awaiter(this, void 0, Promise, function () {
      var searchData, res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.selectedIdList = this.rowSelection.selectedRowKeys = [];
            searchData = this.$util.deepCopy(params);

            if (searchData.audit_status === this.$enum.product.MaintenanceProductStatusEnum.ALL) {
              searchData.audit_status = null;
            }

            return [4, this.$api.product.queryMaintenanceComplianceOfficerList(searchData)];

          case 1:
            res = _a.sent();

            if (res.code === 0) {
              this.data = res.data.list;
              this.total = res.data.total;
            }

            return [2];
        }
      });
    });
  };

  MaintenanceComplianceOfficerPage.prototype.complianceOfficerStatusChange = function (value) {
    this.searchData.page_index = 1;
    this.searchData.audit_status = value;
    this.total = 0;
    this.queryList(this.searchData);
  };

  MaintenanceComplianceOfficerPage.prototype.initSearchData = function () {
    return {
      audit_status: this.$enum.product.MaintenanceProductStatusEnum.WAITING_FOR_MAINTENANCE,
      code_field: this.$enum.product.MaintenanceProductFieldEnum.PRODUCT_SKU,
      code_value: [],
      compliance_company_like: undefined,
      product_eu_uk_type: this.$enum.product.MaintenanceComplianceType.UK,
      compliance_leader_type: undefined,
      manufacturer_name: undefined,
      is_need_compliancer: this.$enum.common.BoolIntEnum.YES,
      category_id: undefined,
      product_name_lang: this.$enum.product.ProductNameLangEnum.PRODUCT_CN,
      product_name_value: undefined,
      page_index: 1,
      page_size: 20
    };
  };

  MaintenanceComplianceOfficerPage.prototype.handleSearch = function () {
    var value = this.docValue ? this.docValue.split(',') : [];
    this.searchData.code_value = value;
    this.searchData.page_index = 1;
    this.queryList(this.searchData);
  };

  MaintenanceComplianceOfficerPage.prototype.handleDblClick = function () {
    var bulkSearchModal = this.$refs.bulkSearchModal;
    bulkSearchModal.modalVisible = true;
    bulkSearchModal.bulkListStr = this.docValue;
  };

  MaintenanceComplianceOfficerPage.prototype.handleBulkFeedback = function (bulkKeywords) {
    this.docValue = bulkKeywords;
  };

  MaintenanceComplianceOfficerPage.prototype.handleReset = function () {
    this.docValue = '';
    this.searchData = this.initSearchData();
    this.queryList(this.searchData);
  };

  MaintenanceComplianceOfficerPage.prototype.handlePageChange = function (pageIndex, pageSize) {
    this.searchData.page_index = pageIndex;
    this.searchData.page_size = pageSize;
    this.queryList(this.searchData);
  };

  MaintenanceComplianceOfficerPage.prototype.handleBatchPrint = function () {
    if (!this.selectedList.length) {
      this.$message.warn(this.t('请选择打印的内容'));
      return;
    }

    var data = this.selectedList.map(function (item) {
      return item.product_sku;
    });
    printComplianceOfficerModal(this, data, true, this.selectedList);
  };

  MaintenanceComplianceOfficerPage.prototype.handlePrint = function (item) {
    printComplianceOfficerModal(this, [item.product_sku], true, [item]);
  };

  MaintenanceComplianceOfficerPage.prototype.handleExportAll = function () {
    var _this = this;

    chooseExportField({
      name: 'maintenanceComponplianceOffcer',
      data: this.maintenanceProductExportFieldEnum,
      onOk: function onOk(data) {
        var searchData = _this.$util.deepCopy(_this.searchData);

        delete searchData.page_index;
        delete searchData.page_size;

        if (searchData.audit_status === _this.$enum.product.MaintenanceProductStatusEnum.ALL) {
          searchData.audit_status = null;
        }

        var params = Object.assign(searchData, {
          export_field_list: data
        });

        _this.exportOutBoundOrder(params);
      }
    });
  };

  MaintenanceComplianceOfficerPage.prototype.handleExportSelected = function () {
    var _this = this;

    if (!this.selectedIdList.length) {
      this.$message.warn(this.tc(this.$config.exportSelectedEmptyTip));
      return;
    }

    chooseExportField({
      name: 'maintenanceComponplianceOffcer',
      data: this.maintenanceProductExportFieldEnum,
      onOk: function onOk(data) {
        var params = {
          export_field_list: data,
          id_list: _this.selectedIdList
        };

        _this.exportOutBoundOrder(params);
      }
    });
  };

  MaintenanceComplianceOfficerPage.prototype.exportOutBoundOrder = function (params) {
    return __awaiter(this, void 0, Promise, function () {
      var res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.product.exportMaintenanceComplianceOfficer(params)];

          case 1:
            res = _a.sent();

            if (res.code === 0) {
              this.$util.exportExcel(res.data);
            }

            return [2];
        }
      });
    });
  };

  MaintenanceComplianceOfficerPage.prototype.handleAdd = function (record) {
    var params = this.$util.deepCopy(record);
    addEditModalCom({
      parent: this,
      propsData: {
        data: params
      }
    });
  };

  MaintenanceComplianceOfficerPage.prototype.handleEdit = function (record) {
    var params = {
      title: '',
      type: this.$enum.common.ModalTypeEnum.EDIT,
      list: [this.$util.deepCopy(record)]
    };
    params.title = this.t('修改英国负责人');
    this.addEditData = params;
    this.addEditVisible = true;
  };

  MaintenanceComplianceOfficerPage.prototype.handleBatchAdd = function () {
    if (!this.selectedList.length) {
      this.$message.warn(this.t('请选择数据。'));
      return;
    }

    this.addEditVisible = true;
    this.addEditData = {
      title: this.t('批量维护英国负责人'),
      type: this.$enum.common.ModalTypeEnum.EDIT,
      list: this.selectedList,
      isGB: true
    };
  };

  MaintenanceComplianceOfficerPage.prototype.handleSuccess = function () {
    this.selectedList = [];
    this.selectedIdList = [];
    this.handleSearch();
  };

  MaintenanceComplianceOfficerPage.prototype.queryProductCateList = function () {
    return __awaiter(this, void 0, void 0, function () {
      var _a, data;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4, this.$api.product.queryProductCateList()];

          case 1:
            _a = _b.sent().data, data = _a === void 0 ? [] : _a;
            this.productCateList = data.map(function (item) {
              return {
                label: item.category_name,
                value: item.category_id
              };
            });
            return [2];
        }
      });
    });
  };

  MaintenanceComplianceOfficerPage.prototype.complianceLeaderTypeText = function (record) {
    return record.compliance_type === this.$enum.product.COMPLIANCE_TYPE.EU && record.compliance_leader_type_text ? "\u3010" + record.compliance_leader_type_text + "\u3011" : '';
  };

  MaintenanceComplianceOfficerPage.prototype.handleDetail = function (record) {
    this.rowData;
    this.rowData.id = record.id;
    this.rowData.title = this.t('合规负责人详情');
    this.detailVisible = true;
  };

  __decorate([enumData('EuroAgents/MaintenanceProductStatusEnum')], MaintenanceComplianceOfficerPage.prototype, "maintenanceProductStatusEnum", void 0);

  __decorate([enumData('EuroAgents/MaintenanceProductFieldEnum')], MaintenanceComplianceOfficerPage.prototype, "maintenanceProductFieldEnum", void 0);

  __decorate([enumData('EuroAgents/MaintenanceProductExportFieldEnum')], MaintenanceComplianceOfficerPage.prototype, "maintenanceProductExportFieldEnum", void 0);

  __decorate([enumData('BoolIntEnum')], MaintenanceComplianceOfficerPage.prototype, "boolEnumList", void 0);

  __decorate([enumData('EuroAgents/AgentTypeEnum')], MaintenanceComplianceOfficerPage.prototype, "agentTypeEnum", void 0);

  __decorate([enumData('EuroAgents/AgentNameTypeEnum')], MaintenanceComplianceOfficerPage.prototype, "agentNameTypeEnum", void 0);

  __decorate([enumData('EuroAgents/ProductNameLangEnum')], MaintenanceComplianceOfficerPage.prototype, "productNameLangEnum", void 0);

  __decorate([loading('loadingStatus')], MaintenanceComplianceOfficerPage.prototype, "queryList", null);

  __decorate([userPrefPageSize('maintenanceComponplianceOffcer')], MaintenanceComplianceOfficerPage.prototype, "initSearchData", null);

  MaintenanceComplianceOfficerPage = __decorate([Component({
    components: {
      BulkSearchModal: BulkSearchModal,
      BatchAddEditModal: BatchAddEditModal,
      DetailModal: DetailModal
    }
  })], MaintenanceComplianceOfficerPage);
  return MaintenanceComplianceOfficerPage;
}(Vue);

export default MaintenanceComplianceOfficerPage;